module.exports.download = require("../src/download");
module.exports.write = require("../src/write");
module.exports.zip = require("../src/zip");
